import React from 'react';
import IncidentWarning from './IncidentWarning';
import { worstLevelBackground, worstLevelFontColor } from '../../utils/colors';
import { Badge, Stack } from '../ui-kit';

const IncidentWarningItem = ({ children, variant, color }) => (
  <h4>
    <Badge className="ms-1" variant={variant} color={color}>
      {children}
    </Badge>
  </h4>
);

// Extending the IncidentWarning component to display station name and
// availability requirements
const IncidentWarningWithDetails = ({ warningStatus, skills, incident, bgColor, onlyShowUnderstaffed }) => {
  const incidentGroupNames = incident.stations.map(station => station.name);

  return (
    <div className="d-inline-block">
      {incidentGroupNames.map(name => (
        <IncidentWarningItem variant="dark" key={name}>
          {name}
        </IncidentWarningItem>
      ))}
      <IncidentWarningItem color={bgColor}>{warningStatus.availability_requirement.name}</IncidentWarningItem>
      {warningStatus.availability_requirement_level && (
        <IncidentWarningItem color={bgColor}>
          {warningStatus.availability_requirement_level.short_code}
        </IncidentWarningItem>
      )}
      <IncidentWarning warningStatus={warningStatus} skills={skills} onlyShowUnderstaffed={onlyShowUnderstaffed} />
    </div>
  );
};

const DispatchedAppliance = ({ incident, task }) => {
  const incidentGroupNames = incident.stations.map(station => station.name);
  return (
    <div className="d-inline-block">
      {incidentGroupNames.map(name => (
        <IncidentWarningItem key={name} variant="dark">
          {name}
        </IncidentWarningItem>
      ))}
      <IncidentWarningItem variant="dark">{task.name}</IncidentWarningItem>
    </div>
  );
};

// renders a wrapper around an incident, and contains the incident warnings, this class
// differs from UnderstaffingWarning: as this displays all warnings, not only the understaffed
// ones, it displays the warnings in a more discrete way.
export const IncidentCrewingContainer = ({ incident, skills, onlyShowUnderstaffed }) => {
  const warningStatuses = incident.warning_statuses;
  // Get the tasks that do not have any warnings associated with them due to not
  // having any availability requirements
  const taskIdsWithWarnings = new Set(warningStatuses.flatMap(ws => ws.availability_requirement.task_ids));
  const tasksWithoutWarnings = (incident.tasks || []).filter(task => !taskIdsWithWarnings.has(task.id));

  return (
    <Stack>
      {tasksWithoutWarnings.map(task => (
        <DispatchedAppliance key={task.id} incident={incident} task={task} />
      ))}
      {warningStatuses.map((ws, index) => (
        <IncidentWarningWithDetails
          key={index}
          warningStatus={ws}
          skills={skills}
          incident={incident}
          onlyShowUnderstaffed={onlyShowUnderstaffed}
          bgColor={worstLevelBackground([ws.warning_level])}
          fColor={worstLevelFontColor([ws.warning_level])}
        />
      ))}
    </Stack>
  );
};
